import React, {Component} from 'react';

import { CSSTransition } from 'react-transition-group';

import html2canvas from 'html2canvas';

import styles from '../../static/css/componentStyleModules/thanksCardMaker.module.scss';

// settingFile
import {validation} from '../../static/js/settingFile/validationData.js';

import thankYouLogo from '../../static/img/thankYouLogo.png';
import FaceIconBaseComponent from '../faceIconComponents/FaceIconBaseComponent';
import InlineRadio from './inputComponent/InlineRadio';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';

export default class ThanksCardMaker extends Component {

    constructor(props){
        super(props);
        this.state = {
            isMemberIconReady:false,
            thankDataToDisplay:{},
            useThanksTitle:true,
            useThanksMemo:true,

            isOutputWindowShown:false,
            isImageReady:false,

            outputImageData:'',
        }
    }

    componentDidMount = () => {
        // setTimeout(() => {
            const cpiedData = JSON.parse(JSON.stringify(this.props.thankData));
            this.setState({
                thankDataToDisplay:cpiedData
            })          
        // },100);
    }

    getMemberImageData = (imageData) => {
        this.refs.imageOutputArea.setAttribute('src',imageData);
        this.setState({isMemberIconReady:true});
    }

    changeThanksTitleRadio = (value) => {
        this.setState({useThanksTitle:value})
    }

    thanksTitleChange = (event) => {
        let newThankData = this.state.thankDataToDisplay;
        newThankData.title = event.target.value;
        this.setState({
            thankDataToDisplay:newThankData
        })          
    }

    changeThanksMemoRadio = (value) => {
        this.setState({useThanksMemo:value})
    }

    thanksMemoChange = (event) => {
        let newThankData = this.state.thankDataToDisplay;
        newThankData.memo = event.target.value;
        this.setState({
            thankDataToDisplay:newThankData
        })          
    }

    outputStart = () => {
        this.setState({
            isImageReady:false,
            isOutputWindowShown:true,
        });
        html2canvas(this.refs.thanksCardDomArea).then((canvas) => {
            //出力するpngを透過pngにするために、1pxのalpha値を操作する
            //twitterで画像が汚くなるのを防ぐために必要
            let ctx = canvas.getContext('2d');
            // canvasのImageDataを取得
            let naturalImgData = ctx.getImageData(0,0,canvas.width,canvas.height);

            //右上1pxのalphaを書き換えて、半透明にする。
            let topRightPoint = (canvas.width - 1) * 4
            naturalImgData.data[topRightPoint + 3] -= 1;

            // 書き換えたImageDataをcanvasへ書き出す
            ctx.putImageData(naturalImgData, 0, 0);

            let imageData = canvas.toDataURL('image/png');
            // let imageTag = this.refs.imgToOutput;

            // imageTag.setAttribute('src',imageData);
            this.setState({outputImageData:imageData});

            this.setState({isImageReady:true});
        });
    }


    render() {
        return (
            <div className={styles['thanksCardMakerArea']}>
              <div className={styles['backButton']}
              onClick={this.props.onCloseButtonClick}>
                <SvgIconBaseComponent image={'cancel'} fillColor={'#ffffff'} />
              </div>

              <div className={styles['thanksCardSettingArea']}>
                <h2>ありがとカードをつくろう！</h2>
                <p>ありがとの内容を画像にできます<br/>LINEやtwitterであの人に送ってみましょう</p>
                <h3>ありがとタイトル</h3>
                <input type="text" 
                className={'thanksLogInput'}
                value={this.state.thankDataToDisplay.title !== undefined ? this.state.thankDataToDisplay.title : '' }
                onChange={this.thanksTitleChange}
                maxLength={validation.thanksTitleMax}
                />
                <div>
                  <InlineRadio 
                  buttonList={[
                      {display:'あり',value:true},{display:'なし',value:false}
                  ]}
                  value={this.state.useThanksTitle}
                  onRadioClick={this.changeThanksTitleRadio}
                  color="hsl(6,77%,62%)"
                  />
                </div>
                <h3>ありがと文</h3>
                <textarea 
                className={'thanksLogInput'}
                value={this.state.thankDataToDisplay.memo} 
                onChange={this.thanksMemoChange}
                maxLength={validation.thanksMemoMax}
                rows="4"
                />
                <div>
                  <InlineRadio 
                  buttonList={[
                      {display:'あり',value:true},{display:'なし',value:false}
                  ]}
                  value={this.state.useThanksMemo}
                  onRadioClick={this.changeThanksMemoRadio}
                  color="hsl(6,77%,62%)"
                  />
                </div>

                <div className={styles['outputButton']}
                onClick={this.outputStart}>カードをつくる</div>
              </div>

              {/* domToImageArea */}
              <div style={{display:'none'}}>
                {/* toConvertSvgMemberIconToImg */}
                <FaceIconBaseComponent 
                head={this.props.memberData.head !== null ? this.props.memberData.head : 'basic'} 
                eyes={this.props.memberData.eyes !== null ? this.props.memberData.eyes : 'basic'} 
                eyeblows={this.props.memberData.eyeblows !== null ? this.props.memberData.eyeblows : 'none'} 
                mouth={this.props.memberData.mouth !== null ? this.props.memberData.mouth : 'basic'} 
                fillColor={this.props.memberData.color !== null ? this.props.memberData.color : '#888888'} 
                onGetImageData={(imgNode) => this.getMemberImageData(imgNode)}
                />
              </div>

              <div className={styles['thanksCardDomArea']} ref="thanksCardDomArea">
                <div className={styles['borderArea']} style={{borderColor:this.props.memberData.color}}>
                  <img className={styles['thankYouLogo']} src={thankYouLogo} alt="thank_you"/>
                  <div className={styles['memberName']}>{this.props.memberData.name}</div>
                  {(this.state.useThanksTitle && this.state.thankDataToDisplay.title !== '') &&
                      <div className={styles['thanksTitle']}>{this.state.thankDataToDisplay.title}</div>
                  }
                  {(this.state.useThanksMemo && this.state.thankDataToDisplay.memo !== '') &&
                      <div className={styles['thanksMemo']}>{this.state.thankDataToDisplay.memo}</div>
                  }
                  <div className={styles['memberIcon']}>
                    <img ref="imageOutputArea" alt="imageOutput" />
                  </div>
                </div>
              </div>

              <CSSTransition
              in={this.state.isOutputWindowShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <div className={styles['thanksCardOutPutWindow']}>

                  <p>画像を保存して LINE や twitter で送ろう！</p>

                  <div className={styles['imageArea']}>
                    <CSSTransition
                    in={this.state.isImageReady === false}
                    timeout={200}
                    classNames="simpleFadeIn200"
                    unmountOnExit
                    mountOnEnter
                    >
                    <div className={styles['loadingDisplay']}>
                      <span>カード準備中...</span>
                    </div>
                    </CSSTransition>
                    <CSSTransition
                    in={this.state.isImageReady === true}
                    timeout={200}
                    classNames="simpleFadeIn200"
                    unmountOnExit
                    mountOnEnter
                    >

                      <img ref="imgToOutput" src={this.state.outputImageData} alt="imgToOutput"/>
                    </CSSTransition>
                  </div>

                  <div className={styles['closeButtonRack']}>
                    <div className={styles['closeButton']} onClick={() => this.setState({isOutputWindowShown:false})}>
                      <SvgIconBaseComponent image={'cancel'} fillColor={'#ffffff'} />
                    </div>
                  </div>

                </div>
              </CSSTransition>



            </div>
        )
    }

};